import { useSuspenseQueries } from '@tanstack/react-query';
import { match } from 'ts-pattern';

import {
    insightsOptions,
    practiceMemberOptions,
    preferencesOptions,
} from '@/entities/practice-member';

import { useOnboardingStep } from '../../../model/use-onboarding-step';
import { OnboardingDashboardSetupStep } from './onboarding-steps/onboarding-dashboard-setup-step';
import { OnboardingEhrPlatformStep } from './onboarding-steps/onboarding-ehr-platform-step';
import { OnboardingIdentifierStep } from './onboarding-steps/onboarding-identifier-step';
import { OnboardingNameTitleStep } from './onboarding-steps/onboarding-name-title-step';
import { OnboardingNoteFormatStep } from './onboarding-steps/onboarding-note-format-step';
import { OnboardingNoteLengthStep } from './onboarding-steps/onboarding-note-length-step';
import { OnboardingTreatmentApproachesStep } from './onboarding-steps/onboarding-treatment-approaches-step';
import { OnboardingWhyStep } from './onboarding-steps/onboarding-why-step';

export function OnboardingSteps() {
    const [preferences, practiceMember, insights] = useSuspenseQueries({
        queries: [preferencesOptions(), practiceMemberOptions(), insightsOptions()],
    });

    const { currentStep, nextStep, progress, stepData, stepForward, stepBackward } =
        useOnboardingStep({
            serverStep: preferences.data?.onboarding?.step,
            practiceMember: practiceMember.data,
            insights: insights.data,
        });

    const stepProps = {
        onNext: stepForward,
        onBack: stepBackward,
        progress,
        stepData,
        nextStep,
    };

    return (
        <div className="flex-1 flex flex-col overflow-hidden">
            {match(currentStep)
                .with('name', () => <OnboardingNameTitleStep {...stepProps} />)
                .with('why', () => <OnboardingWhyStep {...stepProps} />)
                .with('format', () => <OnboardingNoteFormatStep {...stepProps} />)
                .with('length', () => <OnboardingNoteLengthStep {...stepProps} />)
                .with('identifier', () => <OnboardingIdentifierStep {...stepProps} />)
                .with('treatment', () => <OnboardingTreatmentApproachesStep {...stepProps} />)
                .with('ehr', () => <OnboardingEhrPlatformStep {...stepProps} />)
                .with('building', () => <OnboardingDashboardSetupStep />)
                .exhaustive()}
        </div>
    );
}
